import React, { Fragment, useState, useContext } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { RxQuestionMarkCircled } from "react-icons/rx";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { PiShoppingCartThin } from "react-icons/pi";
import { VscMenu } from "react-icons/vsc";
import { HiOutlineXMark } from "react-icons/hi2";
import { FaRegUser } from "react-icons/fa6";
import HelpCenter from "../HelpCenter/MarketHelpCenter";
import UserDropdown from "../MarketUser/UserDropdown";
import MarketAccountDropdown from "../MarketUser/MarketAccountDropdown";
import UserDataFetcher from "../../../libs/getUserbyUserId";
import { CartContext } from "../../../Context/CartContext";
import { AuthContext } from "../../../Context/AuthContext";
import CateMenu from "../ProductCategory/CateMenu";
import { CiUser } from "react-icons/ci";
import MarketSearch from "./MarketSearch";
import { MARKET } from "../libs/marketplaceRoutes";
import "../marketplace-layout.css";

const MarketNavbar = () => {
  const [helpCenterDrop, setHelpCenterDrop] = useState(false);
  const [userDrop, setUserDrop] = useState(false);
  const [userMobileDrop, setUserMobileDrop] = useState(false);
  const [cateMenuDrop, setCateMenuDrop] = useState(false);
  const { cartCount } = useContext(CartContext);
  const { adminData } = UserDataFetcher();
  const { isLoggedIn, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleCateMenuDrop = () => {
    setCateMenuDrop(!cateMenuDrop);
  };

  const handleHelpCenter = () => {
    setHelpCenterDrop(!helpCenterDrop);
  };

  const handleUserDrop = () => {
    setUserDrop(!userDrop);
  };

  const handleUserMoblieDrop = () => {
    setUserMobileDrop(!userMobileDrop);
  };

  return (
    <Fragment>
      {cateMenuDrop && (
        <div className={`drop-down-wrapper ${cateMenuDrop ? "mobile active" : ""}`}>
          <CateMenu />
        </div>
      )}
      <div className="market-shop-nav">
        <div className="marketplace-container market-shop-nav__inner">
          <span>
            <div className="logo-menu">
              {cateMenuDrop ? (
                <HiOutlineXMark
                  className="react-menu"
                  onClick={handleCateMenuDrop}
                  style={{ fontSize: "25px" }}
                />
              ) : (
                <VscMenu
                  className="react-menu"
                  onClick={handleCateMenuDrop}
                  style={{ fontSize: "25px" }}
                />
              )}
              <Link to={MARKET.HOME}>
                <img
                  src="https://i.ibb.co/SywHnkP/Frame-1-1.png"
                  alt="STEX"
                  onClick={() => setCateMenuDrop(false)}
                />
              </Link>
            </div>
            <div className="user-cart">
              <CiUser style={{ fontSize: "25px" }} onClick={handleUserMoblieDrop} />
              {userMobileDrop && <MarketAccountDropdown variant="mobile" />}
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => navigate(MARKET.CART)}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    right: "-2px",
                    padding: "10px",
                    color: "#d0300e",
                  }}
                >
                  {cartCount > 0 ? <p>{cartCount}</p> : null}
                </div>
                <PiShoppingCartThin style={{ fontSize: "30px" }} />
              </div>
            </div>

            <div className="search-input">
              <MarketSearch />
            </div>
            <div className="market-combination">
              <div className="help-center-drop" onClick={handleHelpCenter}>
                <div className="help-center-box">
                  <RxQuestionMarkCircled style={{ fontSize: "25px" }} />
                  <p> Help</p>
                  {helpCenterDrop ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
                {helpCenterDrop && <HelpCenter />}
              </div>

              <div className="user-circle" onClick={handleUserDrop}>
                <FaRegUser style={{ fontSize: "20px" }} />
                {!isLoggedIn && <p>Account</p>}
                {isLoggedIn && (
                  <div className="user-name">
                    <p>{adminData?.user?.first_name || user?.first_name || "Account"}</p>
                  </div>
                )}
                {userDrop && <UserDropdown />}
                {userDrop ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </div>

              <Link to={MARKET.CART} className="cart-count">
                <PiShoppingCartThin style={{ fontSize: "30px" }} />
                <span>My Cart</span>
                {cartCount > 0 ? <p>{cartCount}</p> : null}
              </Link>
            </div>
          </span>
          <div className="rear-search-input">
            <MarketSearch className="market-search--mobile" />
          </div>
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default MarketNavbar;
